module.exports = __webpack_public_path__ + "img/caas3.88ac381b.webp";